// import biboClient from '../services/biboClient';

export default {
  // beforeMount() {
  //   if (!this.$store.state.user.isAuthenticated) {
  //     biboClient
  //       .get('/api/identity')
  //       .then(resp => {
  //         if (resp.data) {
  //           let identity = resp.data;
  //           identity.isAuthenticated = true;
  //           this.$store.commit('updateUser', identity);
  //         }
  //       })
  //       .catch(() => {
  //         this.$store.commit('updateUser', { isAuthenticated: false });
  //
  //         // if (error.response.status === 401) {
  //         //   window.location.href = '/identity/account/login?ReturnUrl=%2F';
  //         // } else if (error.response.status === 403) {
  //         //   window.location.href =
  //         //     '/identity/account/accessdenied?ReturnUrl=%2F';
  //         // }
  //       });
  //   }
  // },
  computed: {
    currentUser() {
      return this.$store.state.user;
    },
  },
  methods: {
    isInRole(role) {
      const user = this.$store.state.user;
      return (user.roles && user.roles.indexOf(role) > -1) || user.isAdmin;
    },
  },
};
